// extracted by mini-css-extract-plugin
module.exports = {"desktopSearchHeader":"kX","sortWrapper":"lX","shortCount":"mX","fullCount":"nX","countWrapper":"oX"};